import {searchFn} from "@helpers/search/search";
import {orderBy} from "lodash";


const filterFn = <T>({filterParams, arr}: {
    filterParams: Record<string, unknown>,
    arr: T[]
}): T[] => {
    return arr.filter((data) => {
        let res = false;
        for (const key in filterParams) {
            const filter = filterParams[key];
            if (!data[key as keyof T]) {
                continue
            }
            if (Array.isArray(filter)) {
                res = filter.includes(data[key as keyof T])
            } else {
                res = filter === data[key as keyof T]
            }
        }
        return res;
    })
}

export const filterArray = <T>({
                            arr,
                            order,
                            direction,
                            filterParams,
                            searchValue,
                            searchKey,
                        }: {
    arr: T[],
    order?: keyof T | false,
    direction?: 'ASC' | 'DESC',
    filterParams?: Record<string, unknown>,
    searchValue?: string,
    searchKey?: keyof T | (keyof T)[],
}): T[] => {


    let result: T[] = [];

    if (!arr) {
        return []
    }

    if (!searchValue && !order && !direction && !filterParams) {
        return arr;
    }
    const directionValue = direction === 'ASC' ? 'asc' : 'desc'

    if (searchValue && searchKey) {
        const searchArr = searchFn({
            data: arr,
            searchValue,
            searchKey
        });
        let filterSearchArr: T[] = [];
        if (filterParams) {
            filterSearchArr = filterFn({arr: searchArr, filterParams})
        }

        if (!order || !direction) {
           return  filterParams ? filterSearchArr : searchArr;
        }

        const _arr = filterParams ? filterSearchArr : searchArr;
        return orderBy(_arr, [order], [directionValue]);

    }

    let filterArr: T[] = [];

    if (filterParams) {
        filterArr = filterFn({arr, filterParams})
    }

    if (!order || !direction) {
        return filterParams ? filterArr : arr;
    }

    const _arr = filterParams ? filterArr : arr;
    result = orderBy(_arr, [order], [directionValue]);

    return result;

}